import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";


import Cimg1 from '../../assets/cimg1.jpg';
import Cimg2 from '../../assets/cimg2.jpg';
import Cimg3 from '../../assets/cimg3.jpg';
import Cimg4 from '../../assets/cimg4.jpg';
import Cimg5 from '../../assets/cimg5.jpg';
import Cimg6 from '../../assets/cimg6.jpg';
import Cimg7 from '../../assets/cimg7.jpg';
import Cimg8 from '../../assets/cimg8.jpg';
import Cimg9 from '../../assets/cimg9.jpg';
import Cimg10 from '../../assets/cimg10.jpg';
import Cimg11 from '../../assets/cimg11.jpg';
import Cimg12 from '../../assets/cimg12.jpg';
import Cimg13 from '../../assets/cimg13.jpg';
import Cimg14 from '../../assets/cimg14.jpg';
import Cimg15 from '../../assets/cimg15.jpg';
import Cimg16 from '../../assets/cimg16.jpg';
import Cimg17 from '../../assets/cimg17.jpg';
import Cimg18 from '../../assets/cimg18.jpg';




const sections = [
  {
   
    images: [Cimg1, Cimg2, Cimg3, Cimg4, Cimg5, Cimg6, Cimg7, Cimg8, Cimg9, Cimg10, Cimg11, Cimg12 , Cimg13, Cimg14, Cimg15, Cimg16 , Cimg17 , Cimg18],
  },
];

const Cricket = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">Cricket Fiesta - 2024</h1>
      <p className="intro-cricket">The Eye Care Institute's Cricket Fiesta 2024 was a smashing success. It was athrilling event and memorable celebration of teamwork and community spirit.</p>
      <br />
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};
export default Cricket